<template>
  <v-container id="recognition" fluid tag="section">
    <v-row>
      <v-col cols="2">
        <v-btn color="primary" @click="$refs.inferenceAddDialog.dialog = true">
          {{ $t("add") }} {{ $t("inference") }} {{ $t("camera") }}
        </v-btn>

        <InferenceAddDialog ref="inferenceAddDialog"></InferenceAddDialog>
      </v-col>

      <v-col cols="2">
        <v-btn
          color="primary"
          @click="confirmFunction($t('deleteConfirm'), removeInferenceCameras)"
        >
          {{ $t("delete") }} {{ $t("inference") }} {{ $t("camera") }}
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" lg="2" v-for="(item, idx) in sortedItems" :key="idx">
        <v-checkbox v-model="item.checked"></v-checkbox>
        <InferenceItem :item="item"> </InferenceItem>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import InferenceItem from "@/components/inference/InferenceItem.vue";
import InferenceAddDialog from "@/components/inference/InferenceAddDialog.vue";
import { getCameras } from "@/endpoint/camera";
import {
  getInferenceCameras,
  removeInferenceCameras,
} from "@/endpoint/inferenceCamera";
import { confirmFunction } from "@/plugins/util";

export default {
  name: "Inference",
  components: {
    InferenceItem,
    InferenceAddDialog,
  },
  data() {
    return {
      cameraItems: [],
      inferenceCameraItems: [],
    };
  },
  created() {
    this.init(this);
  },
  computed: {
    sortedItems() {
      return [...this.inferenceCameraItems].sort((item1, item2) => {
        if (
          item1.camera.camera_name.toUpperCase() <
          item2.camera.camera_name.toUpperCase()
        )
          return -1;

        if (
          item1.camera.camera_name.toUpperCase() >
          item2.camera.camera_name.toUpperCase()
        )
          return 1;

        return 0;
      });
    },
  },
  methods: {
    confirmFunction: confirmFunction,
    async init(scope) {
      scope.inferenceCameraItems = await getInferenceCameras();
      scope.cameraItems = await getCameras();

      return scope;
    },
    removeInferenceCameras() {
      let deleteArray = [];
      this.inferenceCameraItems.forEach((item) => {
        if (item.checked) {
          deleteArray.push(item._id);
        }
      });

      let data = {};
      if (deleteArray.length > 0) {
        data._ids = deleteArray;
      }

      this.$store.dispatch("openOverlay");

      removeInferenceCameras(data)
        .then(() => {
          this.$store.dispatch("closeOverlay");
          this.$router.go();
        })
        .catch(() => {
          this.$store.dispatch("closeOverlay");
        });
    },
  },
};
</script>
